// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"W8-z"};